// extracted by mini-css-extract-plugin
module.exports = {"sectionContainer":"ContentfulAccordionSection_sectionContainer__kFOFw"};